
<div class="container-fluid">
    <div class="performers">
        <div class="performers__notfound" v-if="performers.length === 0">{{ $t('performers.notfound') }}</div>
        <div class="col-xs-6 col-sm-5ths performers__wrapper" v-for="performer in performers">
            <div class="performers__performer">
                <div class="performers__performer-name" v-if="performer">
                    {{ performer.nickname }} | {{ performer.age }} jaar
                </div>
                <div class="performers__performer-status" v-if="performer && performer.performerStatus === 'AVAILABLE'"><i></i></div>
                <div class="performers__performer-advert" v-if="performer">
                    <span>{{ performer.advertId }}</span>
                </div>
                <div class="performers__performer-img">
                    <img v-if="!performer" :src="loader" />
                    <router-link v-if="performer" :to="{ name: 'Profile', params: { id: performer.advertId }}">
                        <img :src="getAvatarImage(performer, 'medium')" />
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    
    <pagination v-if="total != 0" :limit.sync="query.limit" :offset.sync="query.offset" :total="total" :pageButtons="true" :pageCount="true" v-on:pageChange="pageChanged"></pagination>
</div>



// WEBPACK FOOTER //
// ./src/components/pages/performers.tpl.html